import { lazy, useLayoutEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFound from './NotFound';
import { useUserController } from '@maple-tech/auth/userState';
import { userLoggedOut } from '@maple-tech/auth/login';
import LoginRequestBox from './LoginRequest';
import i18n from 'i18next';

const HomePage = lazy(() => import('./HomePage'));
const CheckIn = lazy(() => import('./CheckIn'));
const CheckOut = lazy(() => import('./CheckOut'));

const clearWindowSearch = () => {
  // search değerini temizle ve sayfanın yenilenmesini engelle
  window.history.pushState({}, document.title, window.location.pathname);
};

const AUTO_LOGOUT_HOURS = [0, 6] as const;
const AUTO_LOGOUT_CHECK_INTERVAL_MS = 30 * 1000;

const getNextAutoLogoutTime = (from: Date) => {
  const candidates = AUTO_LOGOUT_HOURS.map((hour) => {
    const candidate = new Date(from);
    candidate.setHours(hour, 0, 0, 0);
    if (candidate.getTime() <= from.getTime()) {
      candidate.setDate(candidate.getDate() + 1);
    }
    return candidate;
  });

  return candidates.reduce((nextCandidate, candidate) => {
    return candidate.getTime() < nextCandidate.getTime()
      ? candidate
      : nextCandidate;
  });
};
// const useAuthHandler = () => {
//   // watch url params
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const userState = useUserController();
//   useLayoutEffect(() => {
//     // check local storage

//     const params = new URLSearchParams(window.location.search);
//     console.log("params",params)
//     // window listener
//     // has params
//     if (params.has('xc')) {
//       if (window.location.search.length < 50) {
//         localStorage.clear();
//         setIsAuthenticated(false);
//         // location.search = '';
//         clearWindowSearch();
//         return;
//       }
//       if (
//         !params.has('xc') ||
//         !params.has('xa') ||
//         !params.has('xu') ||
//         !params.has('sn') ||
//         !params.has('sid')
//       ) {
//         alert('Invalid URL params');
//         setIsAuthenticated(false);
//         localStorage.clear();
//         clearWindowSearch();
//         return;
//       }
//       let xCompany = params.get('xc');
//       let auth = params.get('xa');
//       let xu = decodeURI(params.get('xu'));
//       let storeName = params.get('sn');
//       let storeId = params.get('sid');
//       // print params
//       console.log('xCompany', xCompany);
//       console.log('auth', auth);
//       console.log('xu', xu);
//       console.log('storeName', storeName);
//       console.log('storeId', storeId);
//       // check if params are valid
//       if (!!xCompany && !!auth && !!xu && !!storeName && !!storeId) {
//         // set auth
//         localStorage.setItem('x-company', xCompany);
//         localStorage.setItem('Authorization', auth);
//         localStorage.setItem('@maple/userData', xu);
//         localStorage.setItem('@maple/storeName', storeName);
//         localStorage.setItem('@maple/storeId', storeId);
//         // clear url params
//         userState.setUser(JSON.parse(xu)?.user);

//         userState.refresh();
//         setIsAuthenticated(true);
//         clearWindowSearch();
//       }
//     } else if (
//       !!localStorage.getItem('x-company') &&
//       !!localStorage.getItem('Authorization') &&
//       !!localStorage.getItem('@maple/storeId') &&
//       !!localStorage.getItem('@maple/userData') &&
//       !params.has('xc') &&
//       !params.has('xa')
//     ) {
//       userState.setUser(
//         JSON.parse(localStorage.getItem('@maple/userData'))?.user,
//       );
//       userState.refresh();
//       setIsAuthenticated(true);
//       clearWindowSearch();
//     } else {
//       localStorage.clear();
//       setIsAuthenticated(false);
//       clearWindowSearch();
//     }
//     // location.search = '';
//   }, []);
//   return {
//     isAuthenticated: isAuthenticated && !!userState.user,
//     setIsAuthenticated,
//   };
// };

const useVPNDetection = () => {
  const [vpnDetected, setVpnDetected] = useState(false);
  const checkVpn = async () => {
    // Kullanıcının IP adresini alın
    const userIPresponse = await fetch('https://api.ipify.org?format=json');
    const data = await userIPresponse.json();
    const userIP = data.ip;
    // check localstorage ip validation
    const storedIP = localStorage.getItem('@maple/user-ip-' + userIP);
    if (storedIP === 'vpn-proxy') {
      setVpnDetected(true);
      return;
    }
    const res = await (
      (await fetch(
        'https://rdap.db.ripe.net/ip/45.128.133.202',
        {},
      )) as Response
    ).json();
    console.log('res', res);
  };
  useLayoutEffect(() => {
    // checkVpn();
  }, []);
  return { vpnDetected, checkVpn };
};
const useAuthHandler = () => {
  // watch url params
  const params = new URLSearchParams(window.location.search);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const userState = useUserController();

  useLayoutEffect(() => {
    // check local storage
    let autoLogoutCheckId: ReturnType<typeof window.setInterval> | undefined;
    let nextAutoLogoutAt = getNextAutoLogoutTime(new Date());

    const logout = async () => {
      try {
        await userLoggedOut();
        userState?.logout();
      } catch (e) {
        console.error(e);
      }
      localStorage.clear();
      setIsAuthenticated(false);
      clearWindowSearch();
      window.location.reload();
    };

    const startAutoLogoutWatcher = () => {
      // console.log('Starting auto logout watcher', nextAutoLogoutAt);
      autoLogoutCheckId = window.setInterval(() => {
        // console.log('Checking auto logout', new Date(), nextAutoLogoutAt);
        if (new Date().getTime() < nextAutoLogoutAt.getTime()) {
          return;
        }

        void logout();
        nextAutoLogoutAt = getNextAutoLogoutTime(new Date());
      }, AUTO_LOGOUT_CHECK_INTERVAL_MS);
    };
    // window listener
    // has params
    // if(params.has('xc') && params.has('xa')){
    //   const authService = getAuthService();
    //   authService.setAuthKey(params.get('xa') as string);
    //   authService.setXCompanyID(params.get('xc') as string);
    //   const user = JSON.parse(decodeURI(params.get('xu') as string));
    //   console.log('user', user);
    //   userState.setUser(user.user);
    //   userState.refresh();
    //   // remove search params
    //   clearWindowSearch();
    //   return
    // }else
    if (
      !!localStorage.getItem('x-company') &&
      !!localStorage.getItem('Authorization') &&
      !!localStorage.getItem('@maple/userData') //&&
      // !!localStorage.getItem('@maple/storeId') &&
      // !params.has('xc') &&
      // !params.has('xa')
    ) {
      userState.setUser(
        JSON.parse(localStorage.getItem('@maple/userData'))?.user,
      );
      userState.refresh();

      // localStorage.SetItem('@maple/storeId', userState.user.buildingId);
      /// check last login time / logout user if day passed since last login
      const sessionControlToken = localStorage.getItem('sessionControlToken');
      const currentDay = new Date().getDate();
      const sessionDay = new Date(Number(sessionControlToken)).getDate();
      const isTokenExpired = currentDay !== sessionDay;
      // console.log({
      //   sessionControlToken,
      //   isTokenExpired,
      //   currentDay,
      //   sessionDay,
      // });
      if (isTokenExpired) {
        console.log('TokenExpired logout');
        void logout();
      } else {
        ///

        setIsAuthenticated(true);
        clearWindowSearch();
        startAutoLogoutWatcher();
      }
    } else {
      localStorage.clear();
      setIsAuthenticated(false);
      clearWindowSearch();
    }
    // location.search = '';

    return () => {
      if (autoLogoutCheckId !== undefined) {
        window.clearInterval(autoLogoutCheckId);
      }
    };
  }, []);

  return {
    isAuthenticated: userState.user !== undefined,
    setIsAuthenticated,
  };
};
function App() {
  const { isAuthenticated } = useAuthHandler();
  useVPNDetection();
  useLayoutEffect(() => {
    // kullanıcı dilinin kodunu al
    const userLang = localStorage.getItem('i18nextLng');
    // kullanıcı dilini ayarla
    if (userLang) {
      i18n.changeLanguage(userLang);
    } else {
      // eğer yoksa browser üzerinden öğren
      // @ts-expect-error navigator.userLanguage is only available in some browsers
      const browserLang = (navigator.language || navigator.userLanguage).split(
        '-',
      )[0];
      i18n.changeLanguage(browserLang);
      localStorage.setItem('i18nextLng', browserLang);
      console.log('browserLang', browserLang);
    }
  }, []);
  if (!isAuthenticated) {
    // Kullanıcıya bu uygulamayı kullanamayacağını söyle
    return (
      <>
        <LoginRequestBox />
      </>
    );
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" index element={<HomePage />} />
        <Route path="/check-in" index element={<CheckIn />} />
        <Route path="/check-out" index element={<CheckOut />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
